import React, { useState, useContext, useEffect } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { UserInfo, VisualCache } from '../helper/Context';
import { FileUploadForm, WebUploadForm } from './CreateVisForms';
import SearchComponent from './SearchComponent';
import { shallowCopy } from '../helper/Utils';
import '../pages/Tabs.css';

const CreateVisualFlow = ({ isOrg, onSuccess, lightTheme, onCancel, defaultTab, onlyOneVisual }) => {
    const { userInfo } = useContext(UserInfo);
    const {visCache, setVisCache} = useContext(VisualCache);
    const [activeTab, setActiveTab] = useState(defaultTab || 'upload');
    const [isUploading, setIsUploading] = useState(false);
    const isLoggedIn = userInfo != null;

    const onVisualAdded = (result) => {
        const visCacheCopy = shallowCopy(visCache);
        result.isOrgVis = isOrg;
        visCacheCopy[result.id] = result;
        setVisCache(visCacheCopy);
        if (onSuccess) {
            onSuccess(result);
        }
    };
    const isUploadingDisabled = isUploading && onlyOneVisual;

    return (
        <Tabs
            id="create-visual-tabs"
            activeKey={activeTab}
            onSelect={(k) => !isUploadingDisabled && setActiveTab(k)}
            className="mb-3"
            variant="tabs"
        >
            <Tab eventKey="upload" title="Images, Models, & Videos" disabled={isUploadingDisabled}>
                <FileUploadForm isLoggedIn={isLoggedIn} isOrg={isOrg} onVisualAdded={onVisualAdded} lightTheme={lightTheme} onCancel={onCancel} onlyOneVisual={onlyOneVisual}  setIsUploading={setIsUploading} />
            </Tab>
            <Tab eventKey="web" title="Web Resources (Incl. Molecules)" disabled={isUploadingDisabled}>
                <WebUploadForm isLoggedIn={isLoggedIn} isOrg={isOrg} onVisualAdded={onVisualAdded} lightTheme={lightTheme} onCancel={onCancel} onlyOneVisual={onlyOneVisual} setIsUploading={setIsUploading} />
            </Tab>
            <Tab eventKey="search" title="Search" disabled={isUploadingDisabled}>
                <SearchComponent isOrg={isOrg} onVisualAdded={onVisualAdded} lightTheme={lightTheme} onlyOneVisual={onlyOneVisual} setIsUploading={setIsUploading} />
            </Tab>
        </Tabs>
    );
};

export default CreateVisualFlow; 